import * as React from "react";
import {
  Toolbar,
  makeStyles,
  shorthands,
  ToolbarGroup,
} from "@fluentui/react-components";
import type { ToolbarProps } from "@fluentui/react-components";

export interface GenericToolbarProps extends Partial<ToolbarProps>
{
    actionButtons: React.ReactElement;
    farGroup?: React.ReactElement;
}

const useStyles = makeStyles({
    root: {
        ...shorthands.margin("0px", "0px", "10px"),
        justifyContent: "space-between"  
    },
    toolbarContainer: {
        display: "flex",
        gap: "2px"
    }
});

export const GenericToolbar = (props: GenericToolbarProps) => {
    const classes = useStyles();

    return (
        <Toolbar className={classes.root} aria-label="Default" {...props}>
            <ToolbarGroup className={classes.toolbarContainer} role="presentation">
                { props.actionButtons }
            </ToolbarGroup>
            { props.farGroup &&
                <ToolbarGroup className={classes.toolbarContainer} role="presentation">
                    { props.farGroup }
                </ToolbarGroup>
            }
        </Toolbar>
    );
};